import { makeRequest } from "../http-common";

const InboxDataService = {

    getReplies: async function(id) {
        return makeRequest("get", `/inbox/${id}/replies/`);
    },

    getInbox: async function(id) {
        return makeRequest("get", `/inbox/${id}`);
    },

    reply: async function(id, data) {
        return makeRequest('post', `/inbox/${id}/reply`, data);
    },

    subscribed: async function() {
        return makeRequest('get', `/inbox/subscribed`);
    },

    create: async function(data) {
        return makeRequest('post', `/inbox/create`, data);
    },

    update: async function(id, data) {
        return makeRequest('put', `/inbox/${id}/update`, data);
    },

    participants: async function(id) {
        return makeRequest('get', `/inbox/${id}/participants`);
    },

    deleteMessage: async function(inboxId, messageId) {
        return makeRequest('delete', `/inbox/${inboxId}/message/${messageId}`);
    },

    updateMessage: async function(inboxId, messageId, data) {
        return makeRequest('put', `/inbox/${inboxId}/message/${messageId}`, data);
    },

    addReaction: async function(inboxId, messageId, reactionType) {
        return makeRequest('post', `/inbox/${inboxId}/message/${messageId}/reaction`, { type: reactionType });
    },

};

export default InboxDataService;